import uniqBy from 'lodash/uniqBy';
import {
	type LoadCardCreateConfigSuccessAction,
	LOAD_CARD_CREATE_CONFIG_SUCCESS,
	SET_APP_DATA,
	type SetAppDataAction,
} from '../../../actions/app/index.tsx';
import type { CardTypeEntityState } from './types.tsx';

type Action = SetAppDataAction | LoadCardCreateConfigSuccessAction;

const defaultState: CardTypeEntityState = [];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: CardTypeEntityState = defaultState, action: Action): CardTypeEntityState => {
	switch (action.type) {
		case SET_APP_DATA:
			// cardTypes will not be provided in the payload for CMP
			return action.payload.entities.cardTypes || state;
		case LOAD_CARD_CREATE_CONFIG_SUCCESS:
			return uniqBy([...action.payload.cardTypes, ...state], 'id');
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
